import { create } from 'zustand';
interface CheckoutAddressState {
    selectedAddressId: string | null;
    setSelectedAddressId: (addressId: string | null) => void;
    clearSelectedAddress: () => void;
}

export const useCheckoutAddressStore = create<CheckoutAddressState>()((set) => ({
    selectedAddressId: null,
    setSelectedAddressId: (addressId) => set({ selectedAddressId: addressId }),
    clearSelectedAddress: () => set({ selectedAddressId: null }),
}));

if (typeof window !== 'undefined') {
    window.addEventListener('userLogout', () => {
        useCheckoutAddressStore.getState().clearSelectedAddress();
    });
}
